/**
 * Hourglass internal-staff access control.
 *
 * Gates the `/internal` workspace — a separate dashboard used by Hourglass
 * employees to inspect time entries on behalf of attorneys at the firm whose
 * tenant subdomain they're currently on.
 *
 * v1: any `@hourglass.law` email gets in. If we later need finer-grained
 * permissions (e.g., contractors with `@hourglass.law` who shouldn't see
 * editing), grow this into a `getHourglassPermissions(email)` shaped like
 * `getAdminPermissions` without breaking callers.
 */

export const isHourglassInternal = (_userEmail?: string): boolean => {
  if (!_userEmail) return false;

  // Local visual-testing override: show the Internal workspace for any
  // signed-in user in dev without requiring an @hourglass.law address.
  if (import.meta.env.DEV) return true;

  return _userEmail.toLowerCase().endsWith("@hourglass.law");
};
